import { notificationApi1 } from '@subaio/api-specs'

import { asContainer } from 'lib/container'

import { OpenApi } from 'components/OpenApi'

type State = {}

export const container = asContainer<State>()({
	path: '/apis/notifications/v1',
	title: 'Notification API',
	authentication: { type: 'public' },
	Running: ({ statuspageApi }) => <OpenApi apiDocument={notificationApi1} statuspageApi={statuspageApi} />,
})
